import React from "react";
import { Link, useLocation } from "react-router-dom";

const editorLinks = [
  { name: "Real Estate Orders", path: "/realestate-editor" },
  { name: "Color Correction Orders", path: "/colorcorrection-editor" },
  { name: "Retouching Orders", path: "/retouching-editor" },
  { name: "Wedding Album Orders", path: "/weddingalbum-editor" },
  { name: "Video Editing Orders", path: "/videoediting-editor" },
  { name: "Culling Orders", path: "/culling-editor" },
];

const EditorSidebar = () => {
  const location = useLocation();
  return (
    <div
      className="editor-sidebar bg-light p-3 h-100"
      style={{ minWidth: 220 }}
    >
      <h5 className="mb-4">Editor Dashboard</h5>
      <ul className="nav flex-column">
        {editorLinks.map((link) => (
          <li className="nav-item mb-2" key={link.path}>
            <Link
              to={link.path}
              className={`nav-link${
                location.pathname === link.path
                  ? " active fw-bold text-primary"
                  : " text-dark"
              }`}
            >
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EditorSidebar;
